import { css } from 'styled-components';

import { withOpacity } from '../../utils/colors';
import { BORDER_RADIUS } from './constants';
import type { AlertContainerProps, AlertIconProps } from './types';

export const alertContainerStyle = css<AlertContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: ${({ $color, $type }) => withOpacity($color, $type === 'info' ? 1 : 0.1)};
  border-radius: ${BORDER_RADIUS}px;
  padding: ${({ $hasPaddingForIcon, $isClosable }) =>
    `10px ${$isClosable ? 30 : 15}px 10px ${$hasPaddingForIcon ? 40 : 15}px`};
`;

export const alertTitleStyle = css`
  margin-bottom: 2px;
`;

export const alertMessageStyle = css`
  margin-bottom: 2px;
`;

export const alertIconStyle = css<AlertIconProps>`
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 15px;
  justify-content: center;
  transform: ${({ $isRotated }) => ($isRotated ? 'rotate(-180deg)' : undefined)};
`;

export const alertCloseButtonStyle = css`
  position: absolute;
  top: 5px;
  right: 5px;
`;
